/* src/pages/tis/page-tis.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=page-tis.component-U6VIPE2M.css.map */
